import React from 'react'
import { Route } from 'react-router-dom'
import ChangePassword from './change-password/change-password.page'
import ProfilePage from './profile/profile.page'

const SettingsController = () => {
    return (
        <React.Fragment>
            <Route path="/settings/profile" component={ProfilePage} />
            <Route path="/settings/change-password" component={ChangePassword} />
        </React.Fragment>
    )
}

export default SettingsController
